module.exports = __webpack_public_path__ + "img/orders40.22918602.png";